import React from 'react';


export default function AppFooter() {
    return (
        <> 
        </>
    )

}